import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HotToastService } from '@ngneat/hot-toast';
import { UserOrderDto } from 'src/app/core/dtos/dto';
import { HttpErrorResponseMessages } from 'src/app/core/dtos/http-error-response-messages';
import { AccountService } from 'src/app/core/services/account.service';

@Component({
  selector: 'app-user-orders-by-invoice',
  templateUrl: './user-orders-by-invoice.component.html',
  styleUrls: ['./user-orders-by-invoice.component.scss']
})
export class UserOrdersByInvoiceComponent implements OnInit {
  invoiceId: number;
  userOrders: UserOrderDto[];
  constructor(
    private route: ActivatedRoute,
    private accountService: AccountService,
    private toastService: HotToastService,
  ) { }

  ngOnInit(): void {
    this.invoiceId = this.route.snapshot.params.invoiceid;
    this.populateOrders();
  }

  populateOrders() {
    this.accountService.getOrdersByInvoiceId(this.invoiceId).subscribe(
      result => {
        this.userOrders = result.content;
      },
      (error: HttpErrorResponse) => {
        if (error.status === 400) {
          const errorMessage = error.error as HttpErrorResponseMessages;
          errorMessage.reasons.forEach(reasons => {
            this.toastService.warning(reasons.errorMessage);
          });
        }
      });
  }


}
